import React from "react";
import "./styles.css";

import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";

interface ClientePageShellProps {
  children: React.ReactNode;
  title: string;
  eyebrow?: string;
  subtitle?: string;
  actions?: React.ReactNode;
  className?: string;
  withNavbar?: boolean;
  withFooter?: boolean;
}

export const ClientePageShell = ({
  children,
  title,
  eyebrow = "Omex Capital",
  subtitle,
  actions,
  className = "",
  withNavbar = true,
  withFooter = true,
}: ClientePageShellProps) => {
  return (
    <>
      {withNavbar && <Navbar />}
      <main className={`cliente-page-shell ${className}`.trim()}>
        <section className="cliente-page-hero">
          <div className="cliente-page-hero-copy">
            {eyebrow && <p>{eyebrow}</p>}
            <h1>{title}</h1>
            {subtitle && <span>{subtitle}</span>}
          </div>
          {actions && <div className="cliente-page-hero-actions">{actions}</div>}
        </section>

        <div className="cliente-page-content">{children}</div>
      </main>
      {withFooter && <Footer />}
    </>
  );
};
